var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-descriptions',{attrs:{"title":"","column":_vm.colCount,"colon":""}},_vm._l((Object.keys(_vm.colMap)),function(col){return _c('el-descriptions-item',{key:col,attrs:{"label":`${ _vm.colMap[ col ] }：`}},[_vm._v("\n      "+_vm._s(_vm.data[ col ])+"\n    ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }